import { createFileRoute } from "@tanstack/react-router";
import ListariNelimitate from "@/pages/produs/ListariNelimitate";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/listari-nelimitate/")({
  head: () => routeHead("/listari-nelimitate/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ListariNelimitate />
  );
}
